import React from 'react';
import { FaMapMarkerAlt, FaUtensils, FaCar } from 'react-icons/fa';

const Location = () => {
  return (
    <section className="location-section" id="location">
      <div className="location-content-wrapper">
        <div className="location-text-content">
          <h2>Aventura e Localização</h2>
          <p>Somos vizinhos do Restaurante Pedra do Baú e próximos às Cachoeiras do Encontro, dos Amores e do Toldi. Quer viver a montanha? Oferecemos roteiros de lazer e trilhas com guias experientes para sua total segurança e diversão.</p>
          
          <ul className="location-highlights">
            <li>
              <div className="icon-box"><FaMapMarkerAlt /></div>
              <span>A 5 minutos da Pedra do Baú (Principal cartão postal).</span>
            </li>
            <li>
              <div className="icon-box"><FaUtensils /></div>
              <span>Fácil acesso a vinícolas e restaurantes locais.</span>
            </li>
            <li>
              <div className="icon-box"><FaCar /></div>
              <span>A 27 km de Campos do Jordão (Passeio bate-volta).</span>
            </li>
          </ul>
        </div>
        
        <div className="map-container">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d7351.487661266012!2d-45.6613686!3d-22.6700561!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94cc7d003a47748b%3A0x8d219e9b0beb6ec0!2sChal%C3%A9s%20de%20vidro!5e0!3m2!1spt-BR!2sbr!4v1715886699316!5m2!1spt-BR!2sbr"
            width="100%"
            height="100%"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="Localização do Chalé Safira"
          ></iframe>
        </div>
      </div>
    </section>
  );
};

export default Location;
